const Header = () => {
  return (
    <header className='header'>
      <div className='header-container'>
        <h1>
          Welcome to...<span>songs that slap</span>
        </h1>
        <h3>The place to manage your definitive playlist</h3>
      </div>
    </header>
  );
};

export default Header;
